import React, { useContext, useEffect, useState } from "react";
import StarRatings from "react-star-ratings";
import "./Product_card.css";
import { Link } from "react-router-dom";
import Like_Btn from "../../common_btn/like_btn/Like_Btn";
import { useDispatch, useSelector } from "react-redux";
import { getAllWishlist, postWishlist } from "../../../../features/wishlist/wishlistSlice";
import { Context } from "../../../../utils/context";
import Login_Layout_Modal from "../../modals/login-signup-modals/Login_Layout_Modal";
import { AvgReviewRating } from "../../../../features/reviewRating/reviewRatingSlice";


const Product_card = (props) => {

  const { signin } = useContext(Context);
  const [modelType, setModelType] = useState("");
  const [selectLogin, setSelectLogin] = useState(false);

  const dispatch = useDispatch();

  const postWishlistData = async (data) => {
    const res = await dispatch(postWishlist({ product_id: data }));

    if (res.meta?.requestStatus === "fulfilled") {
      await dispatch(getAllWishlist());
    } else if (res.meta?.requestStatus === "rejected") {
    }

  };
  const allWishlist = useSelector((state) => state.wishlist.allWishlist);



  useEffect(() => {
    if (signin)
      dispatch(getAllWishlist());

  }, [dispatch, props?.id]);

  return (
    <section className="Product_card">
      <Link to={props.link}>
        <div className="img_div">
          <img className="productimg" src={props.image} alt="productimg" />
        </div>
        <div className="contentdiv">
          <p className="prodname">{props.name}</p>
          <div className="row ms-0 me-0">
            <div className="col-7 p-1">
              <p className="subname">{props.subname}</p>
              <StarRatings
                rating={Number(props?.average_rating || 0)}
                starDimension="14px"
                starSpacing="0px"
                starRatedColor="#26a500"
              />
            </div>
            <div className="col-5 p-1">
              <p className="oldprice">₹{props.oldprise}</p>
              <p className="prise">₹{props.prise}</p>
            </div>
          </div>
        </div>
      </Link>

      <div className="wishlist_btn">
        {signin &&
          <Like_Btn
            isActive={allWishlist?.data?.some((item) => item.product_id === props?.id)}  // red if already in wishlist
            onClick={() => postWishlistData(props?.id)}     // remove when clicked
          />
        }
        {!signin &&
          <Like_Btn
            isActive={allWishlist?.data?.some((item) => item.product_id === props?.id)}  // red if already in wishlist
            onClick={() => { setModelType("select_login"); setSelectLogin(true); }}     // remove when clicked
          />
        }
      </div>
      <Login_Layout_Modal
        modalType={modelType}
        show={selectLogin}
        onHide={() => setSelectLogin(false)}
      />
    </section>
  );
};

export default Product_card;
